module.exports = __webpack_public_path__ + "static/media/homeowner1-2.6fb2c079.png";